// Mock data for policies
export const policiesMockData = [
  {
    id: "policy-set-1",
    name: "Customer Service Policies",
    description: "Standard policies for customer-facing agents",
    rules: [
      { 
        id: "rule-1", 
        type: "CONTENT_MATCH", 
        parameters: JSON.stringify({
          patterns: ["social security", "credit card", "passport"],
          threshold: 0.8
        }),
        priority: 90
      },
      { 
        id: "rule-2", 
        type: "USER_BEHAVIOR", 
        parameters: JSON.stringify({
          triggerCount: 3,
          timeWindow: "5m"
        }),
        priority: 70 
      },
      { 
        id: "rule-3", 
        type: "CONTEXT", 
        parameters: JSON.stringify({
          complexityScore: 0.75,
          topics: ["technical", "warranty", "damaged"]
        }),
        priority: 60 
      }
    ],
    actions: [
      {
        id: "action-1",
        type: "BLOCK",
        parameters: JSON.stringify({
          message: "We cannot accept personal information"
        })
      },
      {
        id: "action-2",
        type: "ESCALATE",
        parameters: JSON.stringify({
          team: "support",
          priority: "medium"
        })
      }
    ],
    metrics: {
      totalTriggers: 1248,
      successRate: 92.5,
      averageResponseTime: 2.3,
      actionSuccessRate: 97.1
    },
    status: "ACTIVE",
    createdAt: "2023-09-01T10:00:00Z",
    updatedAt: "2024-01-15T11:30:00Z"
  },
  {
    id: "policy-set-2",
    name: "Product Recommendation Policies",
    description: "Guidelines for product recommendation agents",
    rules: [
      { 
        id: "rule-4", 
        type: "CONTENT_MATCH", 
        parameters: JSON.stringify({
          patterns: ["best deal", "cheapest", "discount"],
          threshold: 0.7
        }),
        priority: 50
      },
      { 
        id: "rule-5", 
        type: "CUSTOM", 
        parameters: JSON.stringify({
          productCheck: "accuracy",
          verifyFields: ["price", "dimensions", "materials"]
        }),
        priority: 80 
      },
      { 
        id: "rule-6", 
        type: "USER_BEHAVIOR", 
        parameters: JSON.stringify({
          behavior: "price_sensitive",
          actions: ["compare", "ask_price", "discount_query"]
        }),
        priority: 65 
      }
    ],
    actions: [
      {
        id: "action-3",
        type: "NOTIFY",
        parameters: JSON.stringify({
          type: "transparency_reminder",
          importance: "high"
        })
      }
    ],
    metrics: {
      totalTriggers: 867,
      successRate: 88.2,
      averageResponseTime: 1.7,
      actionSuccessRate: 94.5
    },
    status: "ACTIVE",
    createdAt: "2023-10-05T14:20:00Z",
    updatedAt: "2024-02-10T09:45:00Z"
  },
  {
    id: "policy-set-3",
    name: "Sustainability Policies",
    description: "Guidelines for discussing sustainability practices",
    rules: [
      { 
        id: "rule-7", 
        type: "CONTENT_MATCH", 
        parameters: JSON.stringify({
          patterns: ["eco-friendly", "carbon footprint", "sustainable"],
          threshold: 0.6
        }),
        priority: 75
      },
      { 
        id: "rule-8", 
        type: "CONTEXT", 
        parameters: JSON.stringify({
          topics: ["environment", "recycling", "climate"],
          intent: "information"
        }),
        priority: 60 
      },
      { 
        id: "rule-9", 
        type: "CUSTOM", 
        parameters: JSON.stringify({
          service_match: ["repair", "recycle", "resell"],
          product_types: ["furniture", "appliances", "electronics"]
        }),
        priority: 70 
      }
    ],
    actions: [
      {
        id: "action-4",
        type: "CUSTOM",
        parameters: JSON.stringify({
          action: "verify_claims",
          data_source: "sustainability_database"
        })
      },
      {
        id: "action-5",
        type: "NOTIFY",
        parameters: JSON.stringify({
          message: "Remember to cite sustainability certification when discussing eco-friendly products"
        })
      }
    ],
    metrics: {
      totalTriggers: 593,
      successRate: 95.1,
      averageResponseTime: 2.0,
      actionSuccessRate: 98.3
    },
    status: "ACTIVE",
    createdAt: "2023-11-12T15:30:00Z",
    updatedAt: "2024-01-28T10:15:00Z"
  },
  {
    id: "policy-set-4",
    name: "Language Safety Controls",
    description: "Ensures AI communication remains appropriate and non-harmful",
    rules: [
      { 
        id: "rule-10", 
        type: "CONTENT_MATCH", 
        parameters: JSON.stringify({
          patterns: ["offensive", "harmful", "inappropriate"],
          strictMode: true,
          threshold: 0.9
        }),
        priority: 95
      },
      { 
        id: "rule-11", 
        type: "USER_BEHAVIOR", 
        parameters: JSON.stringify({
          pattern: "escalation",
          responseTypes: ["agitated", "frustrated", "repeated"]
        }),
        priority: 85 
      }
    ],
    actions: [
      {
        id: "action-6",
        type: "BLOCK",
        parameters: JSON.stringify({
          message: "This response has been blocked due to content safety policies",
          log: true,
          escalate: false
        })
      }
    ],
    metrics: {
      totalTriggers: 312,
      successRate: 99.2,
      averageResponseTime: 1.1,
      actionSuccessRate: 99.8
    },
    status: "ACTIVE",
    createdAt: "2023-12-05T09:20:00Z",
    updatedAt: "2024-02-15T14:30:00Z"
  },
  {
    id: "policy-set-5",
    name: "Data Protection Policies",
    description: "Controls handling of sensitive customer information",
    rules: [
      { 
        id: "rule-12", 
        type: "CONTEXT", 
        parameters: JSON.stringify({
          dataTypes: ["personal", "financial", "contact"],
          actions: ["store", "process", "share"]
        }),
        priority: 99
      }
    ],
    actions: [
      {
        id: "action-7",
        type: "NOTIFY",
        parameters: JSON.stringify({
          message: "Remember to follow data protection protocols",
          requireAcknowledgment: true
        })
      },
      {
        id: "action-8",
        type: "CUSTOM",
        parameters: JSON.stringify({
          action: "anonymize",
          dataTypes: ["name", "address", "phone"]
        })
      }
    ],
    metrics: {
      totalTriggers: 421,
      successRate: 97.3,
      averageResponseTime: 1.5,
      actionSuccessRate: 96.8
    },
    status: "TESTING",
    createdAt: "2024-01-10T11:15:00Z",
    updatedAt: "2024-02-18T15:45:00Z"
  }
];

// Skills mock data matches what's in skills-mock.js but is formatted as a different endpoint response
export const skillsMockApiData = {
  skills: [
    {
      id: "skill-1",
      name: "CustomerLookup",
      description: "Retrieves customer information from the database based on various search criteria",
      status: "ACTIVE",
      createdAt: "2023-09-05T08:45:00Z",
      updatedAt: "2024-01-10T14:20:00Z"
    },
    {
      id: "skill-2",
      name: "ProductSearch",
      description: "Searches the product catalog based on various criteria",
      status: "ACTIVE",
      createdAt: "2023-09-10T11:30:00Z",
      updatedAt: "2024-02-01T09:15:00Z"
    },
    {
      id: "skill-3",
      name: "OrderTracker",
      description: "Retrieves order status and tracking information",
      status: "ACTIVE",
      createdAt: "2023-09-15T13:20:00Z",
      updatedAt: "2024-01-25T16:45:00Z"
    },
    {
      id: "skill-4",
      name: "SustainabilityScore",
      description: "Calculates the sustainability score for a product or order",
      status: "ACTIVE",
      createdAt: "2023-10-01T10:00:00Z",
      updatedAt: "2024-02-05T11:30:00Z"
    },
    {
      id: "skill-5",
      name: "AppointmentScheduler",
      description: "Books appointments for services like assembly, planning, or consultation",
      status: "ACTIVE",
      createdAt: "2023-10-10T09:15:00Z",
      updatedAt: "2024-01-20T14:45:00Z"
    },
    {
      id: "skill-6",
      name: "ProductRecommendation",
      description: "Recommends products based on customer preferences and purchase history",
      status: "ACTIVE",
      createdAt: "2023-10-15T11:20:00Z",
      updatedAt: "2024-02-12T10:30:00Z"
    },
    {
      id: "skill-7",
      name: "StoreInventoryChecker",
      description: "Checks real-time inventory levels at physical stores",
      status: "ACTIVE",
      createdAt: "2023-10-20T14:30:00Z",
      updatedAt: "2024-01-15T09:45:00Z"
    },
    {
      id: "skill-8",
      name: "ReturnProcessor",
      description: "Processes product return requests and generates return labels",
      status: "ACTIVE",
      createdAt: "2023-11-01T10:15:00Z",
      updatedAt: "2024-02-08T13:30:00Z"
    },
    {
      id: "skill-9",
      name: "AssemblyInstructionFinder",
      description: "Retrieves assembly instructions and provides step guidance",
      status: "ACTIVE",
      createdAt: "2023-11-10T09:30:00Z",
      updatedAt: "2024-01-30T11:45:00Z"
    },
    {
      id: "skill-10",
      name: "SentimentAnalyzer",
      description: "Analyzes customer sentiment from conversation context",
      status: "ACTIVE",
      createdAt: "2023-11-15T13:00:00Z",
      updatedAt: "2024-02-10T10:20:00Z"
    }
  ]
};